define([
	"dojo/_base/declare",
	"dojo/topic",
	"csi/_base/DeferredTracking",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/api",
	"csi/comm/GetRequest",
	"csi/def",
	"csi/page/SearchManager",
	"csi/router",
	"csi/session",
	"csi/state/rootStore",
	"csi/utility/routerUtility",
], function(declare, topic, Tracking, _, Controller, api, GetRequest, def, SearchManager, {setLocationUrl}, session, {sessionStore, routerStore}, {LOCATION_URL}) {

	var _getCurrentLocation = function(idPrint) {
		return routerStore.locationType + "/" + (idPrint || session.getLocationValue(session.LOCATION_TAB));
	};

	// keep track of previous URL for logging purpose
	var _lastURL;

	return declare(Controller, {
		/** @property {string} keyLocation - first parameter in URL that changed from last location */
		keyLocation: null,

		/** @property {string} valueLocation - value of first parameter in URL that changed */
		valueLocation: null,

		/**
		 * Call function associated with location key that changed
		 */
		async preProcess() {
			const {keyLocation, valueLocation} = this;

			this.setProgress();

			var f = session.getLocationKeyFunction(keyLocation);
			if (f) {
				try {
					if (keyLocation === LOCATION_URL) {
						await setLocationUrl(valueLocation, routerStore.revisionUrl);
					} else {
						await f(valueLocation);
					}
				} catch (ex) {
					// error during navigation, so restore previous location
					this.m_error = ex.message;
					this.postProcess(false);
					return;
				}
			} else {
				// if navigating to same place, then go straight to postProcess;
				// if navigating within React, then assume route is valid even if no change to registered
				// location keys, as only the root keys (URL, RURL) are registered
				const nodeType = routerStore.locationType;
				const typeDef = def.typeDefinition(nodeType);

				this.postProcess(typeDef.isReact() || undefined);
				return;
			}

			this.process();
		},

		postProcess: function(/*Boolean*/bStatus, /*Boolean*/bRepeat) {
			// summary: post-processing of action

			// if navigation failed or was same as before, then just restore previous location
			if (!bStatus) {
				session.restoreActualLocation();
			}

			// update tracking id to be output to console
			Tracking.id(this.m_action.m_id + ": " + _getCurrentLocation());

			this.inherited(arguments);
		},

		onEnd: function() {
			// log access
			const url = routerStore.locationUrl;
			if (url != _lastURL) {
				_lastURL = url;

				if (_.contains(api.getLoggedNodeTypes(), routerStore.locationType)) {
					new GetRequest("SiteAdmin", "LogAccess")
						.addParameter("URL", url)
						.go();
				}
			}

			// notify others of location change
			topic.publish("/csi/hash/end", _getCurrentLocation());
		},

		start: function() {
			// summary: need to find change in location to update name of action for performance tracking
			this.keyLocation = session.getLocationKeyChanged();
			this.valueLocation = session.getLocationValue(this.keyLocation);

			// notify others of location about to change
			topic.publish("/csi/hash/start");

			// now start action processing
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Publish location to list of last visited
		 */
		toWriter: function() {
			let type = routerStore.locationType;
			const url = routerStore.locationUrl;

			const validTypesMap = {
				"MerchSeason": "MerchPlan",
				"MerchFolderVersion": "MerchFolder",
				"MerchCollectionVersion": "MerchCollection",
				"MerchProductVersion": "MerchProduct",
				"MerchOptionVersion": "MerchOption"
			};

			if (validTypesMap[type] != undefined) {
				type = validTypesMap[type];
			}

			if (SearchManager.getSearchType(type)) {
				sessionStore.addLastVisited(url);
			}
		}
	});
});